/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import type { ComponentType } from 'react';
import ClampLinesModule from 'react-clamp-lines';

export interface ClampLinesProps {
  id: string;
  text: string;
  lines?: number;
  ellipsis?: string;
  buttons?: boolean;
  moreText?: string;
  lessText?: string;
  className?: string;
  delay?: number;
  stopPropagation?: boolean;
  innerElement?: string;
}

// react-clamp-lines is CJS; under Vite ESM the default import can be { default: Component }.
const ClampLines = (
  (ClampLinesModule as { default?: ComponentType<ClampLinesProps> }).default ?? ClampLinesModule
) as ComponentType<ClampLinesProps>;

export default ClampLines;
